module.exports = __webpack_public_path__ + "static/media/edda.b8632c1d.png";